import type { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  container: {
    maxWidth: 800,
    mx: 'auto',
    mt: 4,
    px: 2,
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 16,
      '& fieldset': { borderColor: '#c0c0c0' },
    },
  },
  suggestionBox: {
    backgroundColor: '#f5f5f5',
    p: 2,
    borderRadius: 2,
    fontSize: 14,
    color: '#555',
  },
  buttonBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    mt: 2,
  },
  saveButton: {
    backgroundColor: '#4caf50',
    textTransform: 'none',
    fontWeight: 'bold',
    borderRadius: 16,
    px: 4,
    py: 1,
  },
  link: {
    color: '#1976d2', // azul para link clicável
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  breadcrumbs: {
    fontSize: '0.875rem',
    paddingBottom: '15px',
  },
  breadCurrent: {
    fontSize: '0.875rem',
    color: '#D2691E',
  },
};

export default styles;
